import { Card, IconButton, Text, Flex, ChevronDownIcon } from '@pancakeswap/uikit'
import styled from 'styled-components'

export const CollapseCard = styled(Card)<{ isShow: boolean; isShowDivider: boolean }>`
    padding: 24px;
    border-radius: 0px;
    border-bottom: ${({ isShowDivider, theme }) => (isShowDivider ? `1px solid ${theme.colors.border}` : 'none')};
    @media screen and (max-width:600px) {
        padding: 24px 0px;
    }
`

export const CsIconButton = styled(IconButton)`
    background: transparent;
`
export const CsText = styled(Text)`
    font-size: 14px;
    font-weight: 100 !important;
    font-family: 'Open Sans', sans-serif !important;
`

export const CsTitle = styled(Text)`
    font-size: 16px !important;
`
export const ContainerBanner = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 350px;
    background: url('/images/giftcards/header.png?version=1.1');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    transform: translate3d(0, 0, 0);
    margin-top: -1px;
`

export const ContainerTitleSuggest = styled(Flex)`
    width: calc(100% - 40px);
`

export const Image = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;
`

export const ContainerContent = styled(Flex)`
    width: 60%;
    flex-direction: column;
    gap: 1rem;
    @media screen and (max-width: 600px) {
        width: 100%;
    }
`

export const ContainerSuggest = styled(Flex)`
    width: 40%;
    flex-direction: column;
    gap: 1rem;
    @media screen and (max-width: 600px) {
        display: none;
    }
`
export const ContainerSuggestMobile = styled(Flex)<{isShowSuggest:boolean}>`
    @media screen and (min-width: 601px) {
        display: none;
    }
    flex-direction: column;
    box-shadow: 0px -10px 14px 0px rgba(0, 0, 0, 0.06);
    gap: 1rem;
    width: 100%;
    background:white;
    position: sticky;
    left: 0;
    top:  ${({ isShowSuggest }) => isShowSuggest ? "calc(100vh - 470px)" : "calc(100vh - 96px)"};
    z-index:100;
    padding: 32px 12px 12px 12px;
`

export const CustomContaiFAQ = styled(Flex)<{isShowSuggest:boolean}>`
    width: 100%;
    flex-direction: column;
    @media screen and (max-width:600px) {
        
        margin-top:${({ isShowSuggest }) => isShowSuggest ? "-510px" : "-110px"}; 
    }
`

export const CsChevronDownIcon = styled(ChevronDownIcon)<{isShow: boolean}>`
    transform: ${({ isShow }) => isShow && "rotateX(180deg)"}; 
`
export const CsTitleCollaspe = styled(Text)`
    font-size: 16px !important;
`